import { ApiUtility } from "./ApiUtility";

class GeetGovindServices {
  geetfilterRoute = "/api/settings/filters?lang=";
  magzinedata = "/api/monthlymagazines?lang=";
  magzinedetailRoute = "/api/MonthlyMagazines/";
  favourite = "/api/monthlymagazines/";

  getGeetFilters(productFor: string) {
    return ApiUtility.get(
      this.geetfilterRoute +
      localStorage.getItem("lan") +
      "&productFor=" +
      productFor
    );
  }

  getMonthlyMagazine(
    search: string,
    start: number,
    length: number,
    categoryId: string,
    IsChildLiterature: boolean,
    sort: string,
    authorId: string,
    monthlymagazineLangauge: string,
    isSpecial: boolean,
    subjectId: string
  ) {
    return ApiUtility.get(
      this.magzinedata +
      localStorage.getItem("lan") +
      "&search=" +
      search +
      "&start=" +
      start +
      "&length=" +
      length +
      "&categoryId=" +
      categoryId +
      "&IsChildLiterature=" +
      IsChildLiterature +
      "&sort=" +
      sort +
      "&authorId=" +
      authorId +
      "&monthlymagazineLangauge=" +
      monthlymagazineLangauge +
      "&isSpecial=" +
      isSpecial +
      "&subjectId=" +
      subjectId

    );
  }

  getcurrentGeetGovind(id: string) {
    return ApiUtility.get(
      this.magzinedetailRoute +
      id +
      "?lang=" +
      localStorage.getItem("lan")
    );
  }

  getNavigationDetails(id: string) {
    return ApiUtility.post(this.magzinedetailRoute + "navigation-details", {
      monthlyMagazineId: id,
    });
  }

    getRelatedGeetGovind(id: string) {
      return ApiUtility.get(
        this.magzinedetailRoute +
          id +
          "/related?lang=" +
          localStorage.getItem("lan")
      );
    }


  getGeetGovindDetail = (id: string) => {
    const lang = localStorage.getItem("lan") || "hindi";
    return ApiUtility.get(`${this.magzinedetailRoute}${id}/SEO?lang=${lang}`);
  };

  addGeetGovindFavourite = (id: string) => {
    return ApiUtility.post(this.favourite + id + "/favourite", {});
  };

  removeGeetGovindFavourite = (id: string) => {
    return ApiUtility.delete(this.favourite + id + "/favourite");
  };
}
export default new GeetGovindServices();
